// post
export const GET_POSTS = 'GET_POSTS';
export const ADD_POST = "ADD_POST";
export const ADD_POST_COMPLETE = "ADD_POST_COMPLETE";
export const UPDATE_POST = "UPDATE_POST";
export const DELETE_POST = "DELETE_POST";
export const POST_ERROR = 'POST_ERROR';
export const CLEAR_POSTS = "CLEAR_POSTS";
export const CLEAR_POST_MESSAGES = "CLEAR_POST_MESSAGES";
export const FAVORITE_POST = "FAVORITE_POST";

// auth
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_COMPLETE = "UPDATE_USER_COMPLETE";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const CLEAR_AUTH_MESSAGES = "CLEAR_AUTH_MESSAGES";

// alert
export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";

// tag
export const GET_TAGS = "GET_TAGS";
export const TAG_ERROR = "TAG_ERROR";

// following
export const GET_FRIENDS = "GET_FRIENDS";
export const GET_FRIENDS_ERROR = "GET_FRIENDS_ERROR";
export const GET_SUGGESTED_FRIENDS = "GET_SUGGESTED_FRIENDS";
export const SUGGESTED_FRIEND_ERROR = "SUGGESTED_FRIEND_ERROR";
export const ADD_FRIEND = "ADD_FRIEND";
export const ADD_FRIEND_ERROR = "ADD_FRIEND_ERROR";
export const REMOVE_FRIEND = "REMOVE_FRIEND";
export const REMOVE_FRIEND_ERROR = "REMOVE_FRIEND_ERROR";
export const GET_FOLLOWERS = "GET_FOLLOWERS";
export const GET_FOLLOWERS_ERROR = "GET_FOLLOWERS_ERROR";
export const GET_FEED_REVIEWS = "GET_FEED_REVIEWS";
export const GET_FEED_REVIEWS_ERROR = "GET_FEED_REVIEWS_ERROR";
export const GET_FEED_TRIPS = "GET_FEED_TRIPS";
export const GET_FEED_TRIPS_ERROR = "GET_FEED_TRIPS_ERROR";

// spot
export const GET_SPOTS = "GET_SPOTS";
export const GET_SPOTS_ERROR = "GET_SPOTS_ERROR";
export const GET_SPOT_REVIEWS = "GET_SPOT_REVIEWS";
export const GET_SPOT_REVIEWS_ERROR = "GET_SPOT_REVIEWS_ERROR";
export const GET_SPOT_REVIEW = "GET_SPOT_REVIEW";
export const GET_SPOT_REVIEW_ERROR = "GET_SPOT_REVIEW_ERROR";
export const ADD_SPOT_REVIEW = "ADD_SPOT_REVIEW";
export const ADD_SPOT_REVIEW_ERROR = "ADD_SPOT_REVIEW_ERROR";
export const ADD_SPOT_REVIEW_COMPLETE = "ADD_SPOT_REVIEW_COMPLETE";
export const ADD_DRAFT_SPOT_REVIEW = "ADD_DRAFT_SPOT_REVIEW";
export const REMOVE_DRAFT_SPOT_REVIEW = "REMOVE_DRAFT_SPOT_REVIEW";
export const ADD_DRAFT_SUB_SPOT_REVIEW = "ADD_DRAFT_SUB_SPOT_REVIEW";
export const REMOVE_DRAFT_SUB_SPOT_REVIEW = "REMOVE_DRAFT_SUB_SPOT_REVIEW";
export const UPDATE_SPOT_REVIEW = "UPDATE_SPOT_REVIEW";
export const UPDATE_SPOT_REVIEW_ERROR = "UPDATE_SPOT_REVIEW_ERROR";
export const DELETE_SPOT_REVIEW = "DELETE_SPOT_REVIEW";
export const DELETE_SPOT_REVIEW_ERROR = "DELETE_SPOT_REVIEW_ERROR";
export const DELETE_SPOT_REVIEW_PHOTO = "DELETE_SPOT_REVIEW_PHOTO";
export const DELETE_SPOT_REVIEW_PHOTO_ERROR = "DELETE_SPOT_REVIEW_PHOTO_ERROR";
export const GET_USER_REVIEWS = "GET_USER_REVIEWS";
export const GET_USER_REVIEWS_ERROR = "GET_USER_REVIEWS_ERROR";

// users (admin)
export const GET_USERS = "GET_USERS";
export const GET_USERS_ERROR = "GET_USERS_ERROR";
export const UPDATE_USER_ROLE = "UPDATE_USER_ROLE";
export const UPDATE_USER_ROLE_ERROR = "UPDATE_USER_ROLE_ERROR";

// destination
export const ADD_DESTINATION = "ADD_DESTINATION";
export const ADD_DESTINATION_ERROR = "ADD_DESTINATION_ERROR";
export const ADD_DESTINATION_COMPLETE = "ADD_DESTINATION_COMPLETE";
export const GET_DESTINATIONS = "GET_DESTINATIONS";
export const GET_DESTINATIONS_ERROR = "GET_DESTINATIONS_ERROR";
export const UPDATE_DESTINATION = "UPDATE_DESTINATION";
export const UPDATE_DESTINATION_ERROR = "UPDATE_DESTINATION_ERROR";
export const DELETE_DESTINATION = "DELETE_DESTINATION";
export const DELETE_DESTINATION_ERROR = "DELETE_DESTINATION_ERROR";

// trip
export const ADD_TRIP = "ADD_TRIP";
export const ADD_TRIP_ERROR = "ADD_TRIP_ERROR";
export const ADD_TRIP_COMPLETE = "ADD_TRIP_COMPLETE";
export const GET_TRIPS = "GET_TRIPS";
export const GET_TRIPS_ERROR = "GET_TRIPS_ERROR";
export const GET_TRIP_DETAIL = "GET_TRIP_DETAIL";
export const GET_TRIP_DETAIL_ERROR = "GET_TRIP_DETAIL_ERROR";
export const UPDATE_TRIP = "UPDATE_TRIP";
export const UPDATE_TRIP_ERROR = "UPDATE_TRIP_ERROR";
export const DELETE_TRIP = "DELETE_TRIP";
export const DELETE_TRIP_ERROR = "DELETE_TRIP_ERROR";
export const ATTACH_TRIP_REVIEW = "ATTACH_TRIP_REVIEW";
export const ATTACH_TRIP_REVIEW_ERROR = "ATTACH_TRIP_REVIEW_ERROR";
export const DETACH_TRIP_REVIEW = "DETACH_TRIP_REVIEW";
export const DETACH_TRIP_REVIEW_ERROR = "DETACH_TRIP_REVIEW_ERROR";
export const GET_USER_TRIPS = "GET_USER_TRIPS";
export const GET_USER_TRIPS_ERROR = "GET_USER_TRIPS_ERROR";
